import Browser from '@mindful-web/marko-web/browser';
import Shared from '@watt-global-media/package-global/browser';

Shared(Browser);

export default Browser;
